import { RaRecord, useGetOne, useGetRecordId, useResourceContext } from "react-admin";
import { useAutovioContext } from "./useAutovioContext";
import { useEffect } from "react";

export function useRecordAndSwitchDrivingSchoolIfNecessary<T extends RaRecord>(
  getDrivingSchoolId: (record: T) => string | undefined,
): undefined | T {
  const resource = useResourceContext();
  const id = useGetRecordId();
  const { data: record } = useGetOne(resource, { id }, { enabled: !!(resource && id) });
  const [autovioContext, setAutovioContext] = useAutovioContext();
  const recordDrivingSchoolId = record && getDrivingSchoolId(record);
  const contextDrivingSchoolId = autovioContext.drivingSchoolId;
  useEffect(() => {
    if (!recordDrivingSchoolId) {
      return;
    }
    if (recordDrivingSchoolId !== contextDrivingSchoolId) {
      setAutovioContext({ drivingSchoolId: recordDrivingSchoolId });
    }
  }, [recordDrivingSchoolId, contextDrivingSchoolId]);
  // Do not return the record until recordDrivingSchoolId equals the contextDrivingSchoolId ...
  return record && (recordDrivingSchoolId === contextDrivingSchoolId ? record : undefined);
}
